<template>
  <div v-if="!loading" class="h-100">
    <top-bar
      :fields="fields"
      :per-page="perPage"
      :total="totalRows"
      :filters="filters"
      create-route="productsCreate"
      :havePermissionToCreate="havePermissionToCreate"
      :havePermissionToRemove="havePermissionToRemove"
      @updateFilters="updateFilters"
      @updatePerPage="updatePerPage"
      @updateVisibleFields="updateVisibleFields"
      @removeSelectedItems="removeSelectedItems"
    >
      <template v-slot:actions v-if="havePermissionToCreate">
        <b-button variant="primary" class="ml-1 py-2" v-b-modal.upload-modal>
          <font-awesome-icon :icon="faArrowAltCircleUp" />
          {{ $t("actions.import") }}
        </b-button>
        <upload-modal @updateItems="updateItems" />
        <b-button variant="primary" class="ml-1 py-2" @click.stop="download">
          <font-awesome-icon :icon="faArrowAltCircleDown" />
          {{ $t("actions.export") }}
        </b-button>
      </template>
    </top-bar>
    <template v-if="items.length">
      <b-table
        ref="table"
        :items="items"
        :fields="visibleFields"
        :per-page="perPage"
        :current-page="1"
        borderless
        striped
        responsive
        @head-clicked="updateSortListBy"
      >
        <template slot="HEAD_checkbox">
          <b-checkbox v-model="selectAll" @change="toggleAllSelectedItems" />
        </template>
        <template slot="HEAD_actions">
          <list-display-columns
            :fields="fields"
            @updateVisibleFields="updateVisibleFields"
          />
        </template>
        <template slot="checkbox" slot-scope="data">
          <b-checkbox v-model="data.item.selected" />
        </template>
        <template v-for="field in fields" :slot="`HEAD_${field.field}`">
          <list-table-header
            :key="field.field[0]"
            :field="field"
            :sort-direction="sortDirection"
            :sort-by="sortBy"
          />
        </template>
        <template v-for="field in fields" :slot="field.field" slot-scope="data">
          <span :key="field.field">
            {{ data.item[field.field] }}
          </span>
        </template>
        <template slot="actions" slot-scope="data">
          <table-actions
            :havePermissionToEdit="havePermissionToEdit"
            :havePermissionToRemove="havePermissionToRemove"
            update-route="productsUpdate"
            :data="data"
            @removeItem="removeItem"
          />
        </template>
      </b-table>

      <pagination
        :current-page="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @change="getList"
      />
    </template>
    <template
      v-else
      class="
        w-100
        h-100
        d-flex
        align-items-center
        justify-content-center
        font-weight-bold
      "
    >
      <p>
        {{
          $t("list.no_data", { data: this.$t("menu.products").toLowerCase() })
        }}
      </p>
    </template>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import api from '@/api/products'
import model from '@/models/products'
import actions from '@/mixins/list'
import permissions from '@/mixins/permissions'
import pagination from '@/components/common/pagination'
import listDisplayColumns from '@/components/common/listDisplayColumns'
import listTableHeader from '@/components/common/listTableHeader'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faArrowAltCircleUp,
  faArrowAltCircleDown
} from '@fortawesome/free-regular-svg-icons'
import uploadModal from '@/views/products/uploadModal'
import { exportCSV } from '@/helpers/export'

export default {
  components: {
    pagination,
    listDisplayColumns,
    listTableHeader,
    FontAwesomeIcon,
    uploadModal
  },
  mixins: [actions, permissions],
  data: () => ({
    items: null,
    loading: true,
    api: api,
    fields: model.fields,
    filters: JSON.parse(JSON.stringify(model.filters)),
    visibleFields: [],
    sortBy: 'id',
    sortDirection: 'desc',
    faArrowAltCircleUp,
    faArrowAltCircleDown
  }),
  created() {
    this.init()
  },
  methods: {
    async init() {
      await Promise.all([this.updateVisibleFields(), this.getList()])

      this.loading = false
    },
    updateItems(newItems) {
      this.items = newItems
    },
    async download() {
      const csvFields = {
        columns: [
          'sap_code',
          'aim_code',
          'anf_code',
          'spms_code',
          'commercial_name',
          'dosage',
          'dosage_form',
          'name',
          'presentation',
          'conservation_conditions',
          'price_unit',
          'iva',
          'classification',
          'authorization_date',
          'is_marketed',
          'marketing_date',
          'is_generic_drug',
          'license',
          'taim',
          'quantity_per_package'
        ]
      }

      let exportItems = this.items
      let exportFileName = 'produtos.csv'

      try {
        const response = await this.api.all()
        if (response && response.data) {
          exportItems = response.data.list
        }
      } catch (e) {
        console.error(e)
      }

      if (exportItems.length === 0) {
        return this.$toasted.error(this.$t('actions.invalid_selection'))
      }

      exportCSV(csvFields, exportItems, exportFileName, true)
    }
  }
}
</script>
